import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../breadcrumbs.service';

export interface IBreadcrum {
  icon?: string;
  iconSvg?: boolean;
  text?: string;
  link?: string[];
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
  get breadcrumbs(): IBreadcrum[] {
    // console.log(
    //   `BreadcrumbsComponent.get breadcrumbs: ${JSON.stringify(
    //     this.service.breadcrumbs
    //   )}`
    // );
    return this.service.breadcrumbs;
  }

  constructor(private service: BreadcrumbsService) {}

  ngOnInit(): void {}
}
